const allBuildQueueString = localStorage.getItem('allBuildQueue')
const allBuildQueue = {
    test: [],
    beta: [],
    prod: []
};
try {
    const map = JSON.parse(allBuildQueueString)
    Object.keys(map).forEach(key => {
        if (allBuildQueue[key]) {
            allBuildQueue[key] = map[key] || []
        }
    })
} catch (e) {
    //
}

export default {
    allBuildQueue,
    base: {},
    envMap: {
        test: '测试环境',
        beta: '预发布环境',
        prod: '生产环境'
    },
    // 环境列表
    envList: [
        { value: 'test', label: '测试环境' },
        { value: 'beta', label: '预发布环境' },
        { value: 'prod', label: '生产环境' }
    ],
    appVersion: {
        total: 0,
        items: [],
        refresh: true
    },
    allPublishedAppVersions: {},
    allAppVersions: {},
    lastAppVersions: {},
    lastAppShellVersions: {},

    allEngineVersions: [],
    lastEngineVersions: {},
    allEngineRemarks: {},
    engineRecommended: {},

    tenantList: [],
    tenantVersions: [], // 租户当前使用可用的版本列表
    tenantUpdateVersions: [], // 租户可使用的版本列表
    tenantUpdateInfo: {},    // 某个租户最后更新的信息
    parentAppVersions: {}   // 主应用版本
}
